import angular from 'angular';

module.exports = angular.module('common.filters.sign', [])
.filter('sign', function() {
  return function(input) {
    if (input < 0) {
      return '-';
    } else if (input > 0) {
      return '+';
    } else {
      return '';
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/sign.js
 **/